import { useRef } from "react";
import Chart from "react-apexcharts";

type BarChartProps = {
  options: any;
};

export default function BarChart({ options }: BarChartProps) {
  return (
    <div className="line font-readex">
      {!!options && (
        <Chart
          options={options.options}
          series={options.series}
          width={"100%"}
          height={300}
          type="bar"
          data-cy="barChart"
        />
      )}
    </div>
  );
}
